import * as React from 'react';

import { Root } from './styled';


type BadgeProps = {
	color?: 'green' | 'red' | 'yellow' | 'orange' | 'gray';
}

const Badge: React.SFC<BadgeProps> = ({ color, children }) => {
	return (
		<Root color={color}>{children}</Root>
	);
}

Badge.defaultProps = {
	color: 'gray'
}

export default Badge;
